import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import config from '../../config/config';
import { Sidebar } from '../moderator/Sidebar';
import { Navbar } from '../Navbar';

export function EditExpense() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(true);
  
  // 1. ADDED: Define state for categories
  const [expenseCategories, setExpenseCategories] = useState([]);
  
  // 2. FIXED: Initialize all form fields
  const [formData, setFormData] = useState({
    expenseType: '',
    expenseHead: '',
    buyerName: '',
    rate: '',
    quantity: '',
    amount: '',
    date: '',
    description: ''
  });

  // Fetch Existing Data
  useEffect(() => {
    const fetchExpenseData = async () => {
      try {
        const response = await fetch(`${config.baseUrl}/api/expense/getexpensebyid/${id}`, {
          method: 'GET',
          headers: { 'Content-Type': 'application/json' },
          credentials: 'include'
        });
        if (!response.ok) throw new Error('Expense not found');

        const data = await response.json();
        if (data.exp && data.exp.length > 0) {
          const item = data.exp[0];
          const rawDate = item.date || item.CreatedAt || '';
          const formattedDate = rawDate ? new Date(rawDate).toISOString().split('T')[0] : '';          
         
          setFormData({
              expenseType: item.category_id || '', 
              expenseHead: item.name || '',        
              buyerName: item.buyer_name || '',    
              rate: item.rate || '',               
              quantity: item.qty || '',            
              amount: item.amount || '',           
              date: formattedDate,
              description: item.description || ''
          });
        }
      } catch (error) {
        console.error('Error fetching expense:', error);
      } finally {
        setIsLoading(false);
      }
    };
    fetchExpenseData();
  }, [id]);

  // Fetch Category Types
  useEffect(() => {
    const fetchTypes = async () => {
      try {
        const response = await fetch(`${config.baseUrl}/api/expense/expense-type`, {
          method: 'GET',
          headers: { 'Content-Type': 'application/json' },
          credentials: 'include'
        });
        const data = await response.json();
        // FIXED: Using local state specifically for categories
        setExpenseCategories(Array.isArray(data) ? data : []);
      } catch (error) {
        console.error("Failed to fetch expense types", error);
      }
    };
    fetchTypes();
  }, []);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev =>{
      const newData ={ ...prev, [name]: value };

             if (name === "rate" || name === "quantity") {
                 const rate = name === "rate" ? parseFloat(value) || 0 : parseFloat(prev.rate) || 0;
                 const qty = name === "quantity" ? parseFloat(value) || 0 : parseFloat(prev.quantity) || 0;
                 newData.amount = (rate * qty).toString();
                  }
                  return newData;
       }  );
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const response = await fetch(`${config.baseUrl}/api/expense/updateexpense/${id}`, {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
        credentials: 'include',
        body: JSON.stringify(formData)
      });
      if (!response.ok) throw new Error('Failed to update');
      alert('Expense updated successfully');
      navigate('/expense/view-expense');
    } catch (error) {
      alert('Failed to update expense');
    }
  };

  if (isLoading) return <div className="p-8">Loading expense data...</div>;

  return (<>
  
    < Navbar/>
    < Sidebar />
    <div className="max-w-4xl m-auto pt-5 mt-5">      
      <div className="flex items-center justify-between mb-6">
        <h1 className="text-2xl font-bold text-gray-800">Edit Expense Details <span className="text-green-600">#{id}</span></h1>
      </div>

      <div className="bg-white rounded-xl shadow-sm border border-gray-100 p-8">
        <form onSubmit={handleSubmit} className="space-y-6">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            
            {/* Category Dropdown - CLEANED UP (Only 1 instance) */}
            <div>
              <label className="block text-sm font-semibold text-gray-700 mb-2">Expense Category</label>
              <select
                name="expenseType"
                value={formData.expenseType}
                onChange={handleInputChange}
                className="w-full border border-gray-300 rounded-lg p-2.5 outline-none focus:ring-2 focus:ring-green-500 transition-all"
                required
              >
                <option value="">Select Category</option>
                {expenseCategories.map((type) => (
                  <option key={type.id} value={type.id}>{type.category_name}</option>
                ))}
              </select>
            </div>

            {/* Expense Head */}
            <div>
              <label className="block text-sm font-semibold text-gray-700 mb-2">Expense Head (Item Name)</label>
              <input
                type="text"
                name="expenseHead"
                value={formData.expenseHead}
                onChange={handleInputChange}
                className="w-full border border-gray-300 rounded-lg p-2.5 outline-none focus:ring-2 focus:ring-green-500"
              />
            </div>

            {/* Buyer Name */}
            <div>
              <label className="block text-sm font-semibold text-gray-700 mb-2">Buyer Name</label>
              <input
                type="text"
                name="buyerName"
                value={formData.buyerName}
                onChange={handleInputChange}
                className="w-full border border-gray-300 rounded-lg p-2.5 outline-none focus:ring-2 focus:ring-green-500"
              />
            </div>

            {/* Rate */}
            <div>
               <label className="block text-sm font-semibold text-gray-700 mb-2">Unit Rate (PKR)</label>
               <input
                 type="number"
                 name="rate"
                 value={formData.rate}
                 onChange={handleInputChange}
                 className="w-full border border-gray-300 rounded-lg p-2.5 outline-none focus:ring-2 focus:ring-green-500"
               />
             </div>
             
             {/* Quantity */}
             <div>
               <label className="block text-sm font-semibold text-gray-700 mb-2">Quantity</label>
               <input
                 type="number"
                 name="quantity"
                 value={formData.quantity}
                 onChange={handleInputChange}
                 className="w-full border border-gray-300 rounded-lg p-2.5 outline-none focus:ring-2 focus:ring-green-500"
               />
             </div>

            {/* Total Amount */}
            <div>
              <label className="block text-sm font-semibold text-gray-700 mb-2">Total Amount (PKR)</label>
              <input
                type="number"
                name="amount"
                value={formData.amount}
                onChange={handleInputChange}
                className="w-full border border-gray-300 rounded-lg p-2.5 bg-gray-50 focus:ring-2 focus:ring-green-500 font-bold"
                required
              />
            </div>
          </div>

          <div className="flex items-center justify-end space-x-4 pt-4 border-t border-gray-100">
            <button
              type="button"
              onClick={() => navigate(-1)}
              className="px-6 py-2.5 rounded-lg text-gray-600 hover:bg-gray-100"
            >
              Back
            </button>
            <button
              type="submit"
              className="px-6 py-2.5 bg-green-600 text-white rounded-lg font-semibold hover:bg-green-700 shadow-md"
            >
              Save Changes
            </button>
          </div>
        </form>
      </div>
    </div>
 </> );
}